import React from "react";
import { Seo } from "./components/Seo";
import { FinalCta } from "./components/primitives";
import { Hero, WhoWeAre, Expertise, ServiceCards, ServiceLines, HowWeWork, TransformationStory, CaseStudiesSection, Ecosystem, WhyUs, WorkforceSolutions } from "./home/sections";
import Clients from "./home/Clients";
import SignalSection from "./home/SignalSection";

export default function Home() {
  return (
    <>
      <Seo description="TechAI Fortune is a premium U.S. technology consulting and workforce solutions company. AI, cloud, data, automation, software development and staffing — delivered for business outcomes." />
      <Hero />
      <Clients />
      <WhoWeAre />
      <Expertise />
      <ServiceCards />
      <ServiceLines />
      <HowWeWork />
      <SignalSection />
      <TransformationStory />
      <CaseStudiesSection />
      <Ecosystem />
      <WhyUs />
      <WorkforceSolutions />
      <FinalCta />
    </>
  );
}
